import React from 'react';
import { Block } from 'slate';
import BlockTypes from '../../types/BlockTypes';
import Wrapper from './Wrapper';
import './style.css';
import makeBlockActionButton from '../utils/makeBlockActionButton';
import BlockActionTypes from '../../types/BlockActionTypes';
import { ExpandBlockIcon, NarrowBlockIcon } from '../../components/Icons';
var FULL_WIDTH_BLOCKS = [BlockTypes.TABLE, BlockTypes.DATABASE, BlockTypes.CODES, BlockTypes.IMAGE_GALLERY, BlockTypes.EMBED];
var DATA_FULL_WIDTH = 'data-full-width';

var toggleNodeFullWidth = function toggleNodeFullWidth(editor, node, fullWidth) {
  return editor.setNodeByKey(node.key, {
    data: node.data.set('fullWidth', typeof fullWidth === 'boolean' ? fullWidth : !node.data.get('fullWidth'))
  });
};

export default function FullWidthPlugin() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      containerId = _ref.containerId;

  return [{
    renderBlock: function renderBlock(props, editor, next) {
      if (editor.isBlockExpanded(props.node)) {
        props.attributes[DATA_FULL_WIDTH] = true;
      }

      return next();
    },
    queries: {
      canApplyFullWidth: function canApplyFullWidth(editor, node) {
        return !editor.readOnly && FULL_WIDTH_BLOCKS.includes(node.type);
      },
      isBlockExpanded: function isBlockExpanded(editor, node) {
        return editor.getInContinuousBlock(node, ['data', 'fullWidth']);
      }
    },
    commands: {
      toggleFullWidth: function toggleFullWidth(editor, node) {
        var isFullWidth = editor.getInContinuousBlock(node, ['data', 'fullWidth']);

        if (Block.isBlockList(node.nodes)) {
          return editor.withoutNormalizing(function () {
            return node.getBlocks().map(function (node) {
              return toggleNodeFullWidth(editor, node, !isFullWidth);
            });
          });
        }

        return toggleNodeFullWidth(editor, node, !isFullWidth);
      }
    },
    renderEditor: function renderEditor(props, editor, next) {
      return React.createElement(Wrapper, {
        containerId: containerId
      }, next());
    }
  }, makeBlockActionButton(BlockActionTypes.FULL_WIDTH_EXPAND, {
    index: 2,
    type: BlockActionTypes.ACTION,
    doNotHighlightAndFocusOnClose: true,
    icon: ExpandBlockIcon,
    label: 'Expand to full-width',
    canApply: function canApply(editor, store) {
      var node = store.getItem('node');
      return store.getItem('forcedActions').includes(BlockActionTypes.FULL_WIDTH_EXPAND) && editor.query('canApplyFullWidth', node) && !editor.query('isBlockExpanded', store.getItem('node'));
    },
    onClick: function onClick(editor, node) {
      return editor.command('toggleFullWidth', node);
    }
  }), makeBlockActionButton(BlockActionTypes.FULL_WIDTH_SHRINK, {
    index: 2,
    type: BlockActionTypes.ACTION,
    doNotHighlightAndFocusOnClose: true,
    icon: NarrowBlockIcon,
    label: 'Restore default-width',
    canApply: function canApply(editor, store) {
      var node = store.getItem('node');
      return store.getItem('forcedActions').includes(BlockActionTypes.FULL_WIDTH_SHRINK) && editor.query('canApplyFullWidth', node) && editor.query('isBlockExpanded', store.getItem('node'));
    },
    onClick: function onClick(editor, node) {
      return editor.command('toggleFullWidth', node);
    }
  })];
}